module.exports = __webpack_public_path__ + "818b389e85283f9701520b0d36fffc91.gif";